const types = {
	//Get Template name
	GET_CONTENT_PAGE_START: "GET_CONTENT_PAGE_START",
	GET_CONTENT_PAGE_SUCCESS: "GET_CONTENT_PAGE_SUCCESS",
	GET_CONTENT_PAGE_ERROR: "GET_CONTENT_PAGE_ERROR",
	GET_CONTENT_PAGE_RESET: "GET_CONTENT_PAGE_RESET",

	//Create Template name
	CREATE_CONTENT_PAGE_START: "CREATE_CONTENT_PAGE_START",
	CREATE_CONTENT_PAGE_SUCCESS: "CREATE_CONTENT_PAGE_SUCCESS",
	CREATE_CONTENT_PAGE_ERROR: "CREATE_CONTENT_PAGE_ERROR",
	CREATE_CONTENT_PAGE_RESET: "CREATE_CONTENT_PAGE_RESET",

	//delete Template name
	DELETE_CONTENT_PAGE_START: "DELETE_CONTENT_PAGE_START",
	DELETE_CONTENT_PAGE_SUCCESS: "DELETE_CONTENT_PAGE_SUCCESS",
	DELETE_CONTENT_PAGE_ERROR: "DELETE_CONTENT_PAGE_ERROR",
	DELETE_CONTENT_PAGE_RESET: "DELETE_CONTENT_PAGE_RESET",

	//update Template name
	UPDATE_CONTENT_PAGE_START: "UPDATE_CONTENT_PAGE_START",
	UPDATE_CONTENT_PAGE_SUCCESS: "UPDATE_CONTENT_PAGE_SUCCESS",
	UPDATE_CONTENT_PAGE_ERROR: "UPDATE_CONTENT_PAGE_ERROR",
	UPDATE_CONTENT_PAGE_RESET: "UPDATE_CONTENT_PAGE_RESET",

	//single item  name
	SINGLE_CONTENT_PAGE_START: "SINGLE_CONTENT_PAGE_START",
	SINGLE_CONTENT_PAGE_SUCCESS: "SINGLE_CONTENT_PAGE_SUCCESS",
	SINGLE_CONTENT_PAGE_ERROR: "SINGLE_CONTENT_PAGE_ERROR",
	SINGLE_CONTENT_PAGE_RESET: "SINGLE_CONTENT_PAGE_RESET",
};

export default types;
